
import React from "react";
import  ReactDOM  from "react-dom";
import  "./index.css";
// import "./portfolio/portfolio.css";
// import App from "./App";
// import Wpp from "./App-portfolio/portfolio";
import Wpp from "./portfolio/App-portfolio";
ReactDOM.render(<Wpp />,document.getElementById("root"));
